import React, { Fragment, useState } from 'react';
import { DrawingOptions } from 'utils/constants/Map';
import Proptypes from 'prop-types';
import styles from './index.module.scss';
import Image from '../../Image';
import { images } from 'utils/icons';
import staticText from 'static/text_display.json';
import {
  AddLocationTypeIcon,
  EllipseDrawingMenuIcon,
  MarkerDrawingMenuIcon,
  PolygonDrawingMenuIcon,
  RectangleDrawingMenuIcon,
} from '../../../Icons';
import MenuControlButton from './MapIcons';
import ClearDrawingMenu from './ClearMenu';

export const getDrawingToolIcon = (type = 'default') => {
  switch (type) {
    case DrawingOptions.marker:
      return { icon: <MarkerDrawingMenuIcon className={styles.marker} /> };
    case DrawingOptions.polygon:
      return { icon: <PolygonDrawingMenuIcon /> };
    case DrawingOptions.rectangle:
      return { icon: <RectangleDrawingMenuIcon /> };
    case DrawingOptions.ellipse:
      return { icon: <EllipseDrawingMenuIcon /> };
    default:
      return { icon: <AddLocationTypeIcon /> };
  }
};

const getMenu = ({ onClick, type }, setActiveDrawingTool) => {
  const handleClick = drawingType => {
    setActiveDrawingTool(getDrawingToolIcon(drawingType));
    onClick();
  };
  switch (type) {
    case DrawingOptions.marker:
      return (
        <Image
          src={images.addPoint.default}
          onClick={() => handleClick(DrawingOptions.marker)}
          title={staticText.map.use_point_tool}
        />
      );
    case DrawingOptions.polygon:
      return (
        <Image
          src={images.addPolygon.default}
          onClick={() => handleClick(DrawingOptions.polygon)}
          title={staticText.map.use_polygon_tool}
        />
      );
    case DrawingOptions.rectangle:
      return (
        <Image
          src={images.addSquare.default}
          onClick={() => handleClick(DrawingOptions.rectangle)}
          title={staticText.map.use_rectangle_tool}
        />
      );

    case DrawingOptions.ellipse:
      return (
        <Image
          src={images.addCircle.default}
          title={staticText.map.use_ellipse_tool}
          onClick={() => handleClick(DrawingOptions.ellipse)}
        />
      );
    default:
      return null;
  }
};

getMenu.propTypes = {
  onClick: Proptypes.func.isRequired,
  type: Proptypes.oneOf(Object.values(DrawingOptions)),
};

const DrawingMenuOptions = ({ options, onClear, defaultDrawingTool }) => {
  const [show, setShow] = useState(false);
  const [activeDrawingTool, setActiveDrawingTool] = useState(
    getDrawingToolIcon(defaultDrawingTool),
  );

  const getActiveDrawingTool = iconObject => {
    if (activeDrawingTool && iconObject) {
      return iconObject.icon;
    }
    return <AddLocationTypeIcon />;
  };

  function toggle() {
    setShow(!show);
  }

  const clearDrawings = () => {
    setActiveDrawingTool(getDrawingToolIcon(defaultDrawingTool));
    onClear();
  };

  return (
    <div className={styles.optionsWrapper}>
      <div className={styles.options}>
        <MenuControlButton
          title={staticText.map.change_drawing_tool}
          component={() => getActiveDrawingTool(activeDrawingTool)}
          onClick={toggle}
        />
        <div className={show ? styles.show : styles.hidden}>
          <div className={styles.chevron}></div>
          {options.map(item => (
            <Fragment key={item.type}>
              {getMenu(item, setActiveDrawingTool)}
            </Fragment>
          ))}
        </div>
      </div>
      <ClearDrawingMenu onClick={clearDrawings} />
    </div>
  );
};

DrawingMenuOptions.propTypes = {
  options: Proptypes.arrayOf(getMenu),
  onClear: Proptypes.func,
  defaultDrawingTool: Proptypes.string,
};

export default DrawingMenuOptions;
